<template>
  <div>
    <v-form ref="packageProducts">
      <v-simple-table dense class="dense_table">
        <template v-slot:default>
          <thead>
            <tr>
              <th>{{ $t('message.product.copyWin') }}</th>
              <th>{{ $t('message.layout.product') }}*</th>
              <th>{{ $t('message.product.suppliers') }}</th>
              <th>{{ $t('message.products.unit') }}*</th>
              <th>{{ $t('message.whOrder.unitCost') }}</th>
              <th>{{ $t('message.product.salesPrice') }}</th>
              <th>{{ $t('message.order.qty') }}*</th>
              <th>{{ $t('message.products.operation_type') }}</th>
              <th>{{ $t('message.common.comments') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(element, index) in packageProducts" :key="index" class="pt-4">
              <v-text-field type="text" class="hidden-sm-and-up hidden-sm-and-down" v-model="element.id"></v-text-field>
              <td>
                <v-checkbox dense @change="deSelectAllItems(index)" v-if="element.productworkflow_is_generate_win" v-model="element.iscopywin"></v-checkbox>
              </td>
              <td width="18%">
                  <v-autocomplete v-model ="element.productid" :items="element.products" autocomplete="off"
                  @keyup="$event.keyCode !== 13 ? loadProducts(`searchInput${index}`, index, $event) : ''"
                  :ref="`searchInput${index}`"
                  @click="toggleAllProducts(index, SHOW)"
                  @change="setSuppliers(index)"
                  @focusout="toggleAllProducts(index, HIDE, element.productid)"
                  item-text="product_name" item-value="id" :rules="$_requiredValidation"
                  hide-details full-width dense :placeholder="$t('message.common.typeHere')"></v-autocomplete>
              </td>
              <td width="20%">
                  <v-autocomplete v-model ="element.supplierid" :items="element.suppliers" autocomplete="off"
                  item-text="customer_name" item-value="supplierid"
                  hide-details full-width dense :placeholder="$t('message.common.typeHere')"></v-autocomplete>
              </td>
              <td width="8%">
                <v-select dense :items="list.units" readonly full-width item-text="name" :rules="$_requiredValidation" v-model="element.unit_id" item-value="id" hide-details></v-select>
              </td>
              <td width="8%">
                <v-text-field v-model="element.unitcost" @change="priceCalculationHandler(element)" dense class="mb-n2" :rules="element.unitcost ? $_norwegianNumberValidation : []" hide-details full-width :placeholder="$t('message.common.typeHere')"></v-text-field>
              </td>
              <td width="8%">
                <v-text-field v-model="element.salesprice" @change="priceCalculationHandler(element)" dense class="mb-n2" :rules="element.salesprice ? $_norwegianNumberValidation : []" hide-details full-width :placeholder="$t('message.common.typeHere')"></v-text-field>
              </td>
              <td width="8%">
                <v-text-field v-model="element.qty" @change="priceCalculationHandler(element)" dense class="mb-n2" :rules="element.qty ? $_norwegianNumberMinusValidation : $_requiredValidation" hide-details full-width :placeholder="$t('message.common.typeHere')"></v-text-field>
              </td>
              <td width="15%">
                  <v-autocomplete hide-details full-width :no-data-text="$t('message.common.no_records')" :items="productWorksList" :label="$t('message.products.operation_type')"
                  item-text="name" dense item-value="id" v-model="element.operation_type" autocomplete="off"></v-autocomplete>
              </td>
              <td width="20%">
                <v-text-field v-model="element.comments" dense class="mb-n2" type="text" hide-details full-width :placeholder="$t('message.common.typeHere')"></v-text-field>
              </td>
              <td>
                <v-btn class="mt-2" text fab dark small color="primary" @click="deleteProductRow(index, element.id)">
                  <v-icon dark>mdi-minus-circle</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-form>
    <v-btn class="mx-2 mt-2" fab dark small color="primary" @click="addProductRowHandler">
      <v-icon dark>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>
<script>
export default {
  props: {
    model: {
      type: Object
    },
    list: {
      type: Object
    },
    listOfOperationTypes: {
      type: Array
    },
    modelId: {
      type: Number
    }
  },
  data () {
    return {
      isMain: '',
      packageProducts: [],
      productWorksList: [],
      supplierTransformList: ['supplierprice', 'supplierdiscount', 'discounted', 'shipmentaddon', 'other', 'realcost', 'realcostnok']
    }
  },
  components: {},
  computed: {},
  watch: {},
  mounted () {
    this.getAllPackageProductsHandler()
    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteSuccess', (data) => {
      this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
      this.$store.commit('hideDialog')
      if (data === 'productpackages') this.getAllPackageProductsHandler()
    })
    this.$eventBus.$on('savingParentObj', () => {
      if (this.$refs.packageProducts.validate()) {
        this.$eventBus.$emit('setChildData', this.packageProducts)
      } else {
        this.$eventBus.$emit('setChildData', false)
      }
    })
    if (this.model.productworkflow_states) {
      const workflows = this.model.productworkflow_states ? JSON.parse(this.model.productworkflow_states) : []
      const states = []
      workflows.map(x => {
        const isExistsObj = this.listOfOperationTypes.find(y => y.id === x)
        if (isExistsObj) states.push(isExistsObj)
      })
      this.productWorksList = states
    }
  },
  methods: {
    getProductSuppliers (productId) {
      return new Promise((resolve, reject) => {
        const query = {
          expand: [{
            Model: 'Customer',
            on_field: 'Id',
            on_parent_field: 'supplierid',
            select: ['Name']
          }],
          filter: `productid eq '${productId || 0}'`
        }
        this.$_executeApi('post', 'productsuppliers/query', query)
          .then((response) => {
            const transformData = { number: { list: this.supplierTransformList, format: 'replaceDotWithComma' } }
            const model = this.$_formatListModel(response.data, transformData)
            const supplierId = model.find(x => x.ismain) ? model.find(x => x.ismain).supplierid : 0
            resolve({ list: model, default: supplierId })
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    getAllPackageProductsHandler () {
      const query = {
        expand: [{
          Model: 'Product',
          on_field: 'Id',
          on_parent_field: 'productid',
          select: ['Name', 'Number', 'Workflow_Id'],
          inner_expand: {
            Model: 'ProductWorkFlow',
            on_field: 'Id',
            on_parent_field: 'Workflow_Id',
            select: ['states', 'is_generate_win']
          }
        }],
        filter: `packageid eq ${this.modelId || 0}`
      }
      this.$_executeApi('post', 'productpackages/query', query)
        .then(async (response) => {
          const data = response.data
          const result = []
          for (let i = 0; i < data.length; i++) {
            data[i].products = []
            data[i].products.push({
              id: data[i].productid,
              product_name: data[i].product_number ? `${data[i].product_number} - ${data[i].product_name}` : data[i].product_name
            })
            data[i].operation_type = data[i].operation_type ? +data[i].operation_type : 0
            data[i].suppliers = []
            const lists = await this.getProductSuppliers(data[i].productid)
            data[i].suppliers = lists.list
            result.push(data[i])
          }
          const transformData = { number: { list: ['qty', 'unitcost', 'salesprice'], format: 'replaceDotWithComma' } }
          const modelList = this.$_formatListModel(result, transformData)
          this.packageProducts = this.$formatter.cloneVariable(modelList)
          const isChecked = this.packageProducts.some(x => x.iscopywin)
          if (isChecked && !this.model.batchrequired) this.model.batchrequired = true
          this.$emit('productsLoaded', this.packageProducts)
        })
    },
    // Searching products
    loadProducts (term, index, event) {
      if ([32, 37, 38, 39, 40, 30].indexOf(event.keyCode) > -1) return
      const searchText = this.$refs[term][0].lazySearch
      if (searchText !== null) {
        this.$_executeApi('get', `products/search_for_products?term=${searchText}&productId=${this.modelId || 0}`).then((response) => { /* &productId=${this.model.id} */
          var resultArray = []
          this.packageProducts[index].products = []
          if (response.data.length > 0) {
            response.data.forEach(element => {
              element.product_name = element.number ? `${element.number} - ${element.name}` : element.name
              element.unit_id = element.unitid
              if (element.number !== this.model.number) resultArray.push(element)
            })
            this.packageProducts[index].products = this.$formatter.cloneVariable(resultArray)
          }
        })
      }
    },
    toggleAllProducts (index, action, productId) {
      const items = this.$formatter.cloneVariable(this.packageProducts)
      if (action === this.HIDE) {
        const products = items[index].products.filter(x => x.id === productId)
        items[index].products = products
      }
      this.$set(this.packageProducts, index, items[index])
    },
    deSelectAllItems (index) {
      this.packageProducts.map((x, i) => {
        if (index !== i) x.iscopywin = false
        return x
      })
      const isChecked = this.packageProducts.some(x => x.iscopywin)
      if (isChecked && !this.model.batchrequired) this.model.batchrequired = true
    },
    setSuppliers (index) {
      const obj = this.$formatter.cloneVariable(this.packageProducts[index])
      if (obj) {
        const product = this.packageProducts[index].products.find(x => x.id === obj.productid)
        if (product) {
          obj.salesprice = this.$formatter.replaceDotWithComma(product.salesprice)
          this.$set(this.packageProducts, index, obj)
        }
        var workflow = this.list.workflows.find(x => x.id === product.workflow_id)
        if (workflow && workflow.is_generate_win) {
          obj.productworkflow_is_generate_win = true
          obj.iscopywin = true
          this.$set(this.packageProducts, index, obj)
        }
        // set Unit
        if (product && product.unit_id) {
          obj.unit_id = product.unit_id
          this.$set(this.packageProducts, index, obj)
        }
        // Set Operation Type
        if (product && product.operation_type) {
          obj.operation_type = +product.operation_type
          this.$set(this.packageProducts, index, obj)
        }
        // Set Suppliers
        this.getProductSuppliers(obj.productid)
          .then((response) => {
            obj.suppliers = response.list ? response.list : []
            obj.supplierid = response.default || 0
            const cost = this.$formatter.replaceDotWithComma(product && product.costprice ? product.costprice : 0)
            obj.unitcost = product && product.type === 'work' ? cost : response.cost
            this.$set(this.packageProducts, index, obj)
          })
      } else {
        obj.suppliers = []
        this.$set(this.packageProducts, index, obj)
      }
    },
    getSupplierPrice (model, index) {
      const getSupplier = model.suppliers ? model.suppliers.find(x => x.supplierid === model.supplierid) : {}
      if (getSupplier) {
        const modelObj = this.$formatter.cloneVariable(this.packageProducts[index])
        modelObj.unitcost = getSupplier.realcostnok
        this.$set(this.packageProducts, index, modelObj)
        setTimeout(() => {
          this.priceCalculationHandler()
        })
      }
    },
    priceCalculationHandler () {
      const list = this.$formatter.cloneVariable(this.packageProducts)
      var price = { costprice: 0, salesprice: 0, grosmargin: 0, salespriceincvat: 0 }
      var costPrice = 0
      var salePrice = 0
      if (list != null && list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          var qty = +this.$formatter.replaceCommaWithDot(list[i].qty || 0)
          var costPerUnit = +this.$formatter.replaceCommaWithDot(list[i].unitcost)
          var salePerUnit = +this.$formatter.replaceCommaWithDot(list[i].salesprice)
          costPrice = costPrice + (qty * costPerUnit)
          salePrice = salePrice + (qty * salePerUnit)
        }
      }
      price.costprice = costPrice
      price.salesprice = salePrice
      if (price.costprice > 0) {
        price.grosmargin = ((salePrice - costPrice) / costPrice) * 100
      }
      var getVat = this.model.vatid
      price.salespriceincvat = (price.salesprice * (getVat + 100) / 100)
      const transformData = { number: { list: ['costprice', 'salesprice', 'grosmargin', 'salespriceincvat'], format: 'replaceDotWithComma' } }
      const resultModel = this.$_formatModel(price, transformData)
      this.$emit('priceUpdate', { model: resultModel, iscopy: !this.model.id })
    },
    addProductRowHandler () {
      this.packageProducts.push({ products: [], supplierid: 0 })
    },
    deleteProductRow (index, id) {
      if (this.packageProducts[index].id) {
        const payload = { ids: [id], url: '/productpackages/delete_multiple', module: 'productpackages' }
        this.$store.commit('showDeleteDialog', payload)
      } else this.packageProducts.splice(index, 1)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('savingParentObj')
  }
}
</script>
